import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getInlineLoader } from "../Helpers";
import banner9 from "../assets/banner3.jpg";
import { FaPhoneVolume, FaWhatsapp, FaEnvelope } from "react-icons/fa6";
import { HiOutlineMapPin } from "react-icons/hi2";
import { IoMdMail } from "react-icons/io";

export default function ContactUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  const officeNumbers = [
    { display: "+255 717 918 808", clean: "255717918808" },
    { display: "+255 783 000 766", clean: "255783000766" }
  ];

  return (
    <section className="contact-professional-section py-5">
      <div className="container py-lg-5">
        <div className="row g-5 align-items-center">
          
          {/* LEFT: INFORMATION */}
          <div className="col-lg-6">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h1 className="fw-black text-slate-900 display-5 mb-4">
                Connect with our <span className="text-primary">Experts.</span>
              </h1>
              <p className="text-muted fs-5 mb-5">
                Have questions about compliance or tax strategy? Reach out directly to our 
                team through the official channels below.
              </p>

              {/* SINGLE CONSOLIDATED NUMBER CARD */}
              <div className="professional-number-card p-4 p-md-5 mb-4">
                <div className="row g-4">
                  {officeNumbers.map((num, i) => (
                    <div className="col-12 pb-2" key={i}>
                      <div className="d-md-flex align-items-center justify-content-between gap-3">
                        <div className="mb-3 mb-md-0">
                          <h6 className="font-bold mb-0 text-slate-900">{num.display}</h6>
                        </div>
                        
                        <div className="d-flex gap-2">
                          {/* CALL BUTTON */}
                          <a href={`tel:+${num.clean}`} className="action-btn call-btn" title="Call Now">
                            <FaPhoneVolume /> <span>Call</span>
                          </a>
                          
                          {/* WHATSAPP BUTTON */}
                          <a href={`https://wa.me/${num.clean}`} className="action-btn wa-btn" title="WhatsApp Message">
                            <FaWhatsapp /> <span>WhatsApp</span>
                          </a>
                        </div>
                      </div>
                      {i === 0 && <hr className="opacity-10" />}
                    </div>
                  ))}
                </div>

                <hr/>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="mb-3 mb-md-0">
                    <h6 className="font-bold mb-0 text-slate-900">info@atric.co.tz</h6>
                  </div>
                  
                  <div className="mt-2">
                    <a href="mailto:info@atric.co.tz" className="action-btn wa-btn">
                      <IoMdMail size={24} />
                    </a>
                  </div>
                </div>

              </div>

            </motion.div>
          </div>

          {/* RIGHT: BRAND VISUAL */}
          <div className="col-lg-6">
            <motion.div 
              className="image-frame position-relative"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
            >
              <img src={banner9} alt="Atric Office" className="img-fluid rounded-5 shadow-2xl" />
              <div className="floating-office-info p-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="icon-circle"><HiOutlineMapPin size={22} /></div>
                  <div>
                    <h6 className="text-white mb-1 fw-bold">Mikocheni B</h6>
                    <p className="text-white-50 small mb-0">1<sup>st</sup> Floor, The Tax Hub Building,  <br/> Industrial Road, Mikocheni B.</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

        </div>
      </div>

      <style>{`
        .contact-professional-section { background: #fcfcfd; font-family: 'Inter', sans-serif; }
        .text-slate-900 { color: #0f172a; }
        .text-primary { color: #0284c7 !important; }
        .fw-black { font-weight: 900; }

        /* THE NUMBER CARD */
        .professional-number-card {
          background: #ffffff;
          border-radius: 32px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 10px 30px rgba(0,0,0,0.02);
        }

        /* BUTTON STYLES */
        .action-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          border-radius: 12px;
          font-weight: 700;
          font-size: 0.9rem;
          text-decoration: none;
          transition: all 0.2s ease;
          flex: 1;
          justify-content: center;
        }

        .call-btn {
          background: #f1f5f9;
          color: #0f172a;
        }
        .call-btn:hover {
          background: #0284c7;
          color: white;
        }

        .wa-btn {
          background: #ecfdf5;
          color: #059669;
        }
        .wa-btn:hover {
          background: #22c55e;
          color: white;
        }

        /* IMAGE STYLES */
        .image-frame img {
          width: 100%;
          height: 480px;
          object-fit: cover;
          border-radius: 40px;
        }

        .floating-office-info {
          position: absolute;
          bottom: 25px;
          left: 25px;
          right: 25px;
          background: rgba(15, 23, 42, 0.85);
          backdrop-filter: blur(12px);
          border-radius: 24px;
          border: 1px solid rgba(255,255,255,0.1);
        }

        .icon-circle {
          width: 40px;
          height: 40px;
          background: #0284c7;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media (max-width: 768px) {
          .action-btn { width: 100%; }
        }
      `}</style>
    </section>
  );
}